class CartDrawer extends HTMLElement {
  constructor() {
    super();

    document.addEventListener("addtocart", (event) => {
      this.render().then(() => this.show());
    });

    document.addEventListener("cartlink:click", (event) => {
      this.show();
    });

    if (Theme.URLParams.has("cart")) {
      this.show();
    }
  }

  show() {
    setTimeout(() => {
      this.classList.add("state--active");
    }, 50);
  }

  hide() {
    this.classList.remove("state--active");
  }

  change(data) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify(data)
    });
  }

  render() {
    const current_content = document.getElementById("cart-content");

    function get_new_content(response) {
      const string = JSON.parse(response)["cart-drawer"];
      const parser = new DOMParser();
      const doc = parser.parseFromString(string, "text/html");

      return doc.getElementById("cart-content");
    }

    return fetch("/?sections=cart-drawer")
      .then((response) => response.text())
      .then((response) => {
        current_content.replaceWith(get_new_content(response));
      });
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartOverlay extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-drawer").hide();
    });
  }
}

customElements.define("cart-overlay", CartOverlay);


class CartClose extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-drawer").hide();
    });
  }
}

customElements.define("cart-close", CartClose);

class CartItemQuantity extends HTMLElement {
  constructor() {
    super();

    const CartDrawer = this.closest("cart-drawer");

    const key = this.getAttribute("key");

    const quantity = Number(this.getAttribute("quantity"));

    let data = {
      id: key,
      quantity: quantity
    };

    this.addEventListener("click", (event) => {
      if (event.target.nodeName == "BUTTON") {
        data.quantity += Number(event.target.dataset.increment);
        CartDrawer.change(data).then(() => CartDrawer.render());
      }
    });
  }
}

customElements.define("cart-item-quantity", CartItemQuantity);

class CartItemRemove extends HTMLElement {
  constructor() {
    super();

    const CartDrawer = this.closest("cart-drawer");

    const key = this.getAttribute("key");

    const data = {
      id: key,
      quantity: 0
    };

    this.addEventListener("click", (event) => {
      event.preventDefault();
      CartDrawer.change(data).then(() => CartDrawer.render());
    });
  }
}

customElements.define("cart-item-remove", CartItemRemove);

class CartRecommendation extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define("cart-recommendation", CartRecommendation);
